<template>
  <v-content>
    <v-container v-if="organisations.length > 0" :key="homeOrgId" fluid>
      <v-layout row wrap>
        <h1 class="py-3">{{homeOrg}} Status Overview</h1>
        <!-- Select organisation -->
        <v-flex xs12 sm2>
          <v-select
            class="pl-4"
            label="Organisations"
            :items="organisations"
            item-text="companyname"
            @input="onSelectOrganisation"
            return-object
          ></v-select>
        </v-flex>
       </v-layout>
      <v-btn-toggle v-model="buttonSelected" mandatory>
        <v-layout row wrap>
          <div class="btn-toolbar pa-2 ma-2" v-for="button in buttonProjectGroups" :key="button.id">
            <v-flex xs12 md6>
              <v-spacer></v-spacer>
              <v-btn @click="selectGroup()" depressed :class="button.class">
                <v-icon left>{{button.icon}}</v-icon>
                <span>{{button.groupname}}</span>
              </v-btn>
            </v-flex>
          </div>
        </v-layout>
      </v-btn-toggle>

      <v-alert v-if="error" :value="true" type="error">{{ error }}</v-alert>
      <h1 class="pt-3">
        <span class="font-weight-light">Devices</span>&nbsp;{{getProjectGroupName}}
      </h1>

      <v-container fluid grid-list-lg class="px-0">
        <v-layout row wrap>
          <v-flex xs12>
            <StatusListTable
              :parentID="deviceTypeSelected"
              :days="days"
              :headers="headers"
              :pagination="pagination"
              :metrics="metrics"
              :key="deviceTypeSelected"
              v-on:error="errorHandler"
            />
          </v-flex>
        </v-layout>
      </v-container>

    </v-container>
  </v-content>
</template>

<script>
import { mapGetters } from 'vuex'
import StatusListTable from './StatusListTable'
export default {
  name: 'Home',
  components: { StatusListTable },
  data: () => ({
    homeOrg: '',
    organisations: [],
    homeOrgId: 0,
    days: 0,
    error: false,
    buttonSelected: 0,
    deviceTypeSelected: 0,
    buttonProjectGroups: [],
    buttonDefault: {
      groupname: 'default',
      button: { class: 'normal', icon: 'help' },
      display: 'headers1',
      devicetypeordinal: -1 },
    // From DB
    headersDB: {}, // For the selected group, headers configuration override
    // From OrgSettings.json
    headersconfig: {}, // For the selected group, headers configuration options
    buttonprops: [], // displayed button 'groupname' - class, icon
    headers: [], // passed to StatusListTable - 'data table' column headers, values
    pagination: {}, // passed to StatusListTable - pagination, sort control
    metrics: {} // passed to StatusListTable - computed, counters
  }),
  computed: {
    getProjectGroupName: function () {
      if (this.buttonProjectGroups[this.buttonSelected] !== undefined) {
        return this.buttonProjectGroups[this.buttonSelected].groupname
      } else {
        return null
      }
    },
    ...mapGetters({ vueFrontendConfig: 'vueFrontendConfig' })
  },
  methods: {
    getHeadersConfigurationFromDB () {
      var headersURL = `${window.location.origin}/api/headers`
      // Get the platform predefined V-table column header from DB
      this.$http
        .get('/headers')
        .then(response => {
          try {
            // Normalise/parse the DB header.(NOTE: should already be JSON object)
            this.headersDB = typeof response.data === 'string' ? JSON.parse(response.data) : response.data
          } catch (e) {
            this.headersDB = { 'error': `${e}` }
          }
          // // eslint-disable-next-line
          // console.log('getHeadersConfigurationFromDB')
          // // eslint-disable-next-line
          // console.log(this.headersDB)
        })
        .catch((err) => {
          // eslint-disable-next-line
          console.log(`Error(${err} - fetching DB headers configuration`)
          this.$http.defaults.baseURL = headersURL
        })
    },
    loadOrganisationJsonData () {
      if (this.vueFrontendConfig !== undefined) {
        try {
          this.homeOrg = this.vueFrontendConfig.companyname
          this.buttonprops = this.vueFrontendConfig.buttonprops
          this.days = this.vueFrontendConfig.days
          this.headersconfig = this.vueFrontendConfig.headers
          this.pagination = this.vueFrontendConfig.pagination
          this.metrics = this.vueFrontendConfig.metrics
        } catch (err) {
          this.errorHandler(`Failed to read configuration settings`)
          // eslint-disable-next-line
          console.log(`Error(${err} - reading OrgSettings.json)`)
        }
      }
    },
    onSelectOrganisation (organisation) {
      // // eslint-disable-next-line
      // console.log(organisation)
      this.homeOrg = organisation.companyname
      this.homeOrgId = organisation.id
      this.buttonProjectGroups = []
      this.getProjectGroupsForOrganisation()
    },
    errorHandler (error) {
      this.error = error
    },
    requestFailed (error) {
      this.error = error
    },
    getProjectGroupsForOrganisation () {
      this.$http
        .get('/schemas/projectgroups?parentid=' + this.homeOrgId)
        .then(response => {
          // Populate the buttons, one for each Organisation->projectgroup
          // prettier-ignore
          for (let i = 0; i < response.data.projectgroups.length; i++) {
            const projectgroupname = response.data.projectgroups[i].groupname
            let button = this.buttonDefault.button
            let display = this.buttonDefault.display
            let devicetypeordinal = this.buttonDefault.devicetypeordinal
            if (response.data.projectgroups[i].button !== undefined) {
              // Get the button class from projectgroup DB table configuration
              button = JSON.parse(response.data.projectgroups[i].button)
              display = response.data.projectgroups[i].display
              devicetypeordinal = 0
            } else {
              // otherwise get the button class, properties for the projectgroup from frontend_config
              // .. set button properties matching the 'groupname' from Organisation configuration settings JSON
              for (let j = 0; j < this.buttonprops.length; j++) {
                const configgroupname = this.buttonprops[j].groupname
                if (configgroupname.localeCompare(projectgroupname) === 0) {
                  button = this.buttonprops[j].button
                  display = this.buttonprops[j].display
                  devicetypeordinal = this.buttonprops[j].devicetypeordinal
                  break
                }
              }
            }
            this.buttonProjectGroups.push(
              Object.assign(
                {},
                response.data.projectgroups[i],
                button,
                { 'display': display, 'devicetypeordinal': devicetypeordinal }
              )
            )
          }
          this.selectGroup()
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(`Error(${error} - fetching/parsing projectgroups`)
          this.requestFailed('Failed to retrieve and/or parse groups data.')
        })
    },
    selectGroup () {
      // if devicetypeordinal is undefined or -1
      //   select the highest version 'devicetype_id' button->devicetype[] (if more than 1 devicetype)
      // else
      //   select the prefered ordinal index (0 based) from config file
      var index = 0
      var id = 0
      if (this.buttonProjectGroups[this.buttonSelected] !== undefined) {
        var ordinal = this.buttonProjectGroups[this.buttonSelected].devicetypeordinal
        for (var i = 0; i < this.buttonProjectGroups[this.buttonSelected].devicetypes.length; i++) {
          // Assumption that newer version devicetypes will have higher DB table 'id'
          var currentId = this.deviceTypeSelected = this.buttonProjectGroups[this.buttonSelected].devicetypes[i]
          if (ordinal !== undefined && ordinal === i) {
            index = i
            break
          } else {
            if (currentId > id) {
              id = currentId
              index = i
            }
          }
        }
        this.deviceTypeSelected = this.buttonProjectGroups[this.buttonSelected].devicetypes[index]
        // Set up the V-Table configuration
        if (this.headersDB !== undefined) {
          // Scan the returned headersDB[] and get matching header object with key === display
          let obj = this.headersDB.headers[this.buttonProjectGroups[this.buttonSelected].display]
          if (obj !== undefined) {
            // Override defaults from DB configuration
            this.headers = obj.columns
            this.pagination = obj.pagination
            this.days = obj.days
            this.metrics = obj.metrics
          }
        }
      } else {
        // otherwise use frontend JSON
        this.headers = this.headersconfig[this.buttonProjectGroups[this.buttonSelected].display]
      }
    }
  },
  beforeUpdate () {
    // Select the first DeviceType to follow selected button
    if (this.buttonProjectGroups) {
      this.selectGroup()
    }
  },
  beforeMount () {
    // Get the frontend JSON and header overides from DB
    this.loadOrganisationJsonData()
    this.getHeadersConfigurationFromDB()

    // Get the Orgs and pre-select the homeOrg
    this.$http
      .get('/schemas/organisations')
      .then(response => {
        this.organisations = response.data.organisations
        // Scan the returned orgainsations and find HOME_ORG
        for (var i = 0; i < this.organisations.length; i++) {
          if (this.organisations[i].companyname.localeCompare(this.homeOrg) === 0) {
            // Now fetch the Organisation Project Groups.
            this.homeOrgId = this.organisations[i].id
            this.getProjectGroupsForOrganisation()
            break
          }
        }
      })
      .catch(() => this.requestFailed('Failed to retrieve Organisation data'))
  }
}
</script>
